import { Slice } from "store/utils/slice";
import type { EntityState } from "store/utils/types";

type State = {
  recommendedDatasources: string[];
};

type UserState = EntityState<State>;

export default new Slice<UserState>("user", {
  entity: {
    recommendedDatasources: [],
  },
  loading: {} as any,
  error: {} as any,
});
